import { render, staticRenderFns } from "./ClientPortalIntegrationForm.vue?vue&type=template&id=fb713350&"
import script from "./ClientPortalIntegrationForm.vue?vue&type=script&lang=js&"
export * from "./ClientPortalIntegrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports